import {VideoDescription} from "./videoDescription.model";
import {DocumentDescription} from "./documentDescription.model";

export enum DocumentType {
    VIDEO = "VIDEO",
    DOCUMENT = "DOCUMENT"
}

export interface DocumentWrapper {
    type: DocumentType;
    data?: VideoDescription | DocumentDescription;
}

export class DocumentWrapperModel implements DocumentWrapper {
    type: DocumentType;
    data?: VideoDescription | DocumentDescription;

    constructor(type: DocumentType, data?: VideoDescription | DocumentDescription) {
        this.type = type;
        this.data = data;
    }

    /**
     * Check if this wrapper is for a video
     */
    isVideo(): boolean {
        return this.type === DocumentType.VIDEO;
    }

    /**
     * Check if this wrapper is for a document
     */
    isDocument(): boolean {
        return this.type === DocumentType.DOCUMENT;
    }

    /**
     * Get the data as VideoDescription (with type checking)
     */
    getVideoDescription(): VideoDescription | undefined {
        if (this.isVideo() && this.data) {
            return this.data as VideoDescription;
        }
        return undefined;
    }

    /**
     * Get the data as DocumentDescription (with type checking)
     */
    getDocumentDescription(): DocumentDescription | undefined {
        if (this.isDocument() && this.data) {
            return this.data as DocumentDescription;
        }
        return undefined;
    }

}
